import { EscapeRoute } from "@/commons/interface/building/escape-route"
import { StdResponse, bimAxios } from "@/config/axios"


export function getEscapeRoutes(projectUuid: string, modelUuid: string, type: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/escape-routes`, {
        params: {
            ...params,
            type: type,
            modelUuid: modelUuid,
        }
    })
}

export function addEscapeRoute(projectUuid: string, modelUuid: string, data: EscapeRoute, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/escape-routes`, data, {
        params: {
            ...params,
        }
    })
}


export function updateEscapeRoute(uuid: string, data: EscapeRoute, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/escape-routes/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteEscapeRoute(projectUuid: string, escapeRouteUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/escape-routes/${escapeRouteUuid}`, {
        params: {
            ...params,
        }
    })
}
